import { createRoute, redirect } from "@tanstack/react-router";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";
import { rootRoute } from "@/routes/root";
import { AdminDashboard } from "@/features/admin/components/AdminDashboard";
import { adminSearchSchema } from "@/features/admin/types";

const getAdminRoles = (): string[] => ["Admin"];

export const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin",
  staticData: { title: "Admin" },
  validateSearch: adminSearchSchema,
  beforeLoad: ({ context }) => {
    const adminRoles = getAdminRoles();

    if (adminRoles.length === 0) {
      return;
    }

    const userRoles = context.getUserRoles();
    const isAuthorized = adminRoles.some((role) => userRoles.includes(role));

    if (!isAuthorized) {
      throw redirect({ to: "/auth/unauthorized", replace: true });
    }
  },
  component: AdminDashboard,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
});
